import { GraphGroup } from './GraphGroup';
import { GroupType } from '@ardoq/api-types';
import type { ItemLabels, RawGraphNode2 } from '../types';
import { componentInterface } from '@ardoq/component-interface';
import { componentOperations } from '@ardoq/core';
import { DiffType } from '@ardoq/data-model';
import { countDescendantComponents } from './utils';
import { componentGroupTypes } from './consts';
import { ComponentGraphGroupModel } from './types';

export class CollapsibleGraphGroup
  extends GraphGroup
  implements ComponentGraphGroupModel
{
  static createFrom(
    { id, modelId, label, type, subLabels, children }: RawGraphNode2,
    collapsed = false,
    itemLabels?: ItemLabels,
    isContext = false
  ) {
    if (!type) {
      throw Error('Invalid group.');
    }
    return new CollapsibleGraphGroup(
      modelId ?? '',
      label ?? '',
      type,
      subLabels,
      id,
      collapsed,
      countDescendantComponents(children ?? []),
      itemLabels,
      isContext
    );
  }
  private readonly _isComponent: boolean;
  public collapsed: boolean;
  public readonly descendantCount;
  public readonly isContext: boolean;
  itemLabels: ItemLabels | undefined;
  private constructor(
    modelId: string,
    label: string,
    type: GroupType,
    subLabels?: string[],
    id?: string,
    collapsed = false,
    descendantCount = 0,
    itemLabels?: ItemLabels,
    isContext = false
  ) {
    super(modelId, label, type, subLabels, id);
    this.collapsed = collapsed;
    this.descendantCount = descendantCount;
    this._isComponent = componentGroupTypes.has(type);
    this.itemLabels = itemLabels;
    this.isContext = isContext;
  }
  override getVisualDiffType(): DiffType {
    const component = componentInterface.get(this.modelId);
    return component
      ? componentOperations.getVisualDiffType(component)
      : DiffType.NONE;
  }
  override isComponent() {
    return this._isComponent;
  }
  getShape() {
    return componentInterface.getShape(this.modelId) || 'predefinedProcess';
  }
  getImage() {
    return componentInterface.getImage(this.modelId) ?? '';
  }
  protected getRawHash() {
    return `${super.getRawHash()}${Number(this.collapsed)}${Number(this.isContext)}`;
  }
}
